import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { LicenseModel } from '../../../../../typings/api/skymap/rest/v0/.common';
import { useReloadPage } from '../../hooks/use-reload-page';
import { Button } from '../button/button';
import { Dialog } from '../dialog/dialog';
import { InfoBox } from '../info-box/info-box';

type Props = {
  license: LicenseModel;
};

const DesignLicenseAddedInfoDialog = (props: Props) => {
  const { t } = useTranslation();
  const { isReloading, reload } = useReloadPage();

  return (
    <Dialog width={600} onClose={reload}>
      {{
        header: t('designLicenseAddedInfoDialog.title', { ns: 'components' }),
        content: (
          <>
            <InfoBox color="green" leftIcon={{ icon: ['fad', 'check'] }}>
              <Trans
                components={{
                  bold: <strong />,
                  br: <br />,
                }}
                i18nKey="designLicenseAddedInfoDialog.info"
                ns="components"
                values={{
                  companyName: props.license.company!.name,
                }}
              />
            </InfoBox>
          </>
        ),
        footer: {
          right: (
            <>
              <Button
                color="primary"
                disabled={isReloading}
                loading={isReloading}
                variant="contained"
                onClick={reload}
              >
                {t('designLicenseAddedInfoDialog.button', { ns: 'components' })}
              </Button>
            </>
          ),
        },
      }}
    </Dialog>
  );
};

export { DesignLicenseAddedInfoDialog };
